import React from "react"
import styles from "./styles.module.scss"

const LayoutContainer = ({ className, title, description, primaryAction, children }) => {
  let classes = styles.layoutInfo
  if (className) classes = `${classes} ${className}`
  return (
    <div className={classes}>
      {(title || description) && (
        <header className={styles.layoutInfo__header}>
          <h3>{title}</h3>
          <p>{description}</p>
          {primaryAction && (
            <div className={styles.primaryAction}>
              {primaryAction}
            </div>
          )}
        </header>
      )}
      {children}
    </div>
  )
}

export default LayoutContainer
